import { Link } from "react-router-dom";
import { GrUserSettings } from "react-icons/gr";

const BOTUsersButton = () => {

    return (

        <div align="center">            
            <Link to="/bousers">
                <button className="menu-btn" type="button"><GrUserSettings  />&nbsp;&nbsp;BO Users</button>
            </Link>            
        </div>

    )
}

export default BOTUsersButton;